import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { HttpStatus } from '../shared/enums/http-status.enum';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../shared/services/login.service';
import { LoginError } from '../login/login/login.component';

export const SKIP_401_INTERCEPTOR = new HttpContextToken(() => false);
@Injectable()
export class UnauthorizedResponseInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly dialogRef = inject(MatDialog);
  private readonly login = inject(LoginService);


  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === HttpStatus.Unauthorized) {
        const { accessToken, currentRealmId } = this.login.user ?? {};
        if (accessToken && currentRealmId && req.context.get(SKIP_401_INTERCEPTOR) !== true) {
          return from(this.login.selectRealm(currentRealmId)).pipe(
            catchError(_ => {
              this.logout();
              return throwError(error);
            }),
            switchMap(_ => {
              req = req.clone({
                setHeaders: {
                  Authorization: this.login.user.realmAccessToken.toString(),
                }
              });
              return next.handle(req);
            })
          );
        } else {
          this.logout();
          return throwError(error);
        }
      }
      return throwError(error);
    }));
   }

   private logout(): void {
    this.dialogRef.closeAll();
    this.login.logout();
    this.router.navigate(['/login'], { queryParams: { error: LoginError.LoginTimeout } });
   }
}
